import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";
import { clearAllCache } from "./queryInvalidate";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("tm_user") || "null");
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const setSession = useCallback((token, u) => {
    if (token) localStorage.setItem("tm_token", token);
    if (u) localStorage.setItem("tm_user", JSON.stringify(u));
    setUser(u || null);
  }, []);

  const login = useCallback(async (email, password, mfa_code) => {
    const { data } = await api.post("/auth/login", { email, password, mfa_code });
    setSession(data.token, data.user);
    return data;
  }, [setSession]);

  const registerOwner = useCallback(async (payload) => {
    const { data } = await api.post("/auth/register-owner", payload);
    setSession(data.token, data.user);
    return data;
  }, [setSession]);

  const acceptInvite = useCallback(async (payload) => {
    const { data } = await api.post("/auth/accept-invite", payload);
    setSession(data.token, data.user);
    return data;
  }, [setSession]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem("tm_token");
    localStorage.removeItem("tm_user");
    clearAllCache();
    setUser(null);
    window.location.href = "/login";
  }, []);

  const refreshMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      localStorage.setItem("tm_user", JSON.stringify(data));
    } catch {
      /* ignore */
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("tm_token")) {
      refreshMe();
    }
  }, [refreshMe]);

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, registerOwner, acceptInvite, refreshMe, setSession }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
